import { render, staticRenderFns } from "./DashProviderService.vue?vue&type=template&id=58694a8a&"
import script from "./DashProviderService.vue?vue&type=script&lang=js&"
export * from "./DashProviderService.vue?vue&type=script&lang=js&"
import style0 from "./DashProviderService.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports